// extracted by mini-css-extract-plugin
module.exports = {"symbolFill":"UrgentIcon__symbolFill___W3LU4"};